// Lenis Smooth Scrolling Initialization
document.addEventListener('DOMContentLoaded', () => {
  if (typeof Lenis === 'undefined') return;

  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktopQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  let lenisInstance = null;
  let rafId = null;

  function destroyLenis() {
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }

    if (lenisInstance) {
      lenisInstance.destroy();
      lenisInstance = null;
      window.lenis = null;
    }
  }

  function createLenis() {
    destroyLenis();

    lenisInstance = new Lenis({
      duration: 0.9,
      easing: (t) => 1 - Math.pow(1 - t, 3),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 1,
    });

    window.lenis = lenisInstance;

    function raf(time) {
      if (!lenisInstance) return;
      lenisInstance.raf(time);
      rafId = requestAnimationFrame(raf);
    }

    rafId = requestAnimationFrame(raf);
  }

  function syncLenis() {
    if (reducedMotionQuery.matches || !desktopQuery.matches) {
      destroyLenis();
      return;
    }

    if (!lenisInstance) {
      createLenis();
    }
  }

  anchorLinks.forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      if (!lenisInstance) return;

      const targetId = this.getAttribute('href').substring(1);
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      e.preventDefault();
      lenisInstance.scrollTo(target);
    });
  });

  syncLenis();

  if (typeof reducedMotionQuery.addEventListener === 'function') {
    reducedMotionQuery.addEventListener('change', syncLenis);
    desktopQuery.addEventListener('change', syncLenis);
  } else {
    reducedMotionQuery.addListener(syncLenis);
    desktopQuery.addListener(syncLenis);
  }
});
